import { FC } from 'react';
import QuizIcon from '@mui/icons-material/Quiz';
import { useTranslation } from 'react-i18next';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import { FIELD_TYPES } from '../../Form/form.utils';
import ContentRenderer from '../Content/ContentRenderer';
import QuizWrapper from './QuizWrapper';
import ContentTitleWithIcon from '../../Simple/ContentTitle/ContentTitleWithIcon';

type QuizLayoutProps = {
	field: IEntityContentField;
	handleQuizCompleted: (isCompleted: boolean) => void;
};

const QuizLayout: FC<QuizLayoutProps> = ({ field, handleQuizCompleted }) => {
	const { t, i18n } = useTranslation();
	const currentLanguage: string = i18n.language;
	const { reference } = field;
	return (
		<div style={{ marginBottom: '50px' }}>
			{reference?.content[currentLanguage]?.map((block: IEntityContentField) => {
				if (block.type === FIELD_TYPES.TEXT) {
					return (
						<div key={block.name}>
							<ContentTitleWithIcon
								id={field.id}
								content={block.content || t('quiz')}
								icon={QuizIcon}
							/>
						</div>
					);
				}
				if (block.type === FIELD_TYPES.RICH_EDITOR) {
					return <ContentRenderer html={block.content} key={block.name} />;
				}
				if (block.type === FIELD_TYPES.QUIZ_EDITOR) {
					return (
						<QuizWrapper
							questions={block.options.questions}
							key={block.name}
							handleQuizCompleted={handleQuizCompleted}
						/>
					);
				}
			})}
		</div>
	);
};

export default QuizLayout;
